import Store from '@/store'

/**
 * Wipes everything a login left in the browser: the auth part of the persisted Vuex store
 * (user, active role, roles, menus) and all of localStorage / sessionStorage.
 * Store first: vuex-persistedstate re-saves the store into localStorage on every change,
 * so clearing storage first would let it write the old user / role straight back.
 * Used by logout, the 401 handler and the idle-timeout logout.
 */
const clearLoginData = () => {
  Store.dispatch('Auth/clearAuthStorageOnLogout')
  Store.dispatch('Auth/updateAuthUser', null)
  Store.commit('mutateCommonProperties', {
    hasDropdownLoaded: false
  })
  localStorage.clear()
  sessionStorage.clear()
}

export default clearLoginData
